<template>
  <section class="offer" v-if="offerItems">
    <div class="cia-container">
      <div class="offer__header">
        <h2 class="animation-item animation-top">Oferta</h2>
      </div>
      <div class="offer__content">
        <div class="offer__list">
          <div
            v-for="(offerItem, index) in offerItems"
            :key="index"
            class="offer__item animation-item animation-top"
            :class="`animation-item--delay${index}`">
            <div class="offer__inner">
              <div class="offer__icon">
                <div class="offer__icon-image">
                  <img :class="offerItem.icon"
                       :src="require(`@/assets/icons/${offerItem.icon}.svg`)"
                    :alt="offerItem.header"
                  />
                </div>
              </div>
              <h2 v-html="offerItem.header"></h2>
              <p v-html="offerItem.description"></p>
            </div>
          </div>
        </div>
        <div class="offer__detail animation-item animation-top">
          <p>W CELU WYCENY USŁUGI SKONTAKTUJ SIĘ Z NAMI</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'offer',
  data: () => ({
    offerItems: [
      {
        icon: 'icon-docs2',
        header: 'Przechowywanie dokumentacji w&nbsp;postaci tradycyjnej',
        description: 'Tradycyjna archiwizacja w specjalistycznych pomieszczeniach z zachowaniem odpowiednich warunków klimatycznych',
      },
      {
        icon: 'icon-3d_scan',
        header: 'Pełnowymiarowe skanowanie 3D ',
        description: 'Przekonwertowanie geometrii trójwymiarowych obiektów rzeczywistych do postaci cyfrowej',
      },
      {
        icon: 'icon-destroy',
        header: 'Niszczenie dokumentacji oraz zasobów',
        description: 'Niszczenie dokumentacji oraz zasobów z zachowaniem obowiązujących procedur z możliwością wydania certyfikatu bezpiecznego zniszczenia',
      },
      {
        icon: 'icon-3d_print',
        header: 'Wydruk 3D',
        description: 'Wydruk 3D z różnych komponentów materiałowych - filamentów',
      },
      {
        icon: 'icon-format',
        header: 'Skanowanie dokumentów w różnych formatach A4, A3 itp.',
        description: 'Skanowanie dokumentów do różnych formatów plików (tiff, jpeg, pdf) indeksowanie - tworzenie baz danych - możliwość archiwum elektronicznego',
      },
      {
        icon: 'icon-app',
        header: 'Aplikacja dla przechowywania danych cyfrowych w chmurze',
        description: 'Innowacyjna archiwizacja zdigitalizowanych danych – możliwość przechowywania obiektów 3D',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
  .offer {
    padding: 100px 0 60px;
    @media (min-width: 1000px) {
      padding: 140px 0 120px;
    }
    &__header {
      color: #fff;
      text-align: center;
      padding-bottom: 45px;
      @media (min-width: 1000px) {
        padding-bottom: 65px;
      }
      h2,
      h3 {
        font-weight: 300;
      }
      h2 {
        font-size: 26px;
        @media (min-width: 550px) {
          font-size: 34px;
        }
        @media (min-width: 1000px) {
          font-size: 44px;
        }
      }
      h3 {
        font-size: 16px;
      }
    }
    &__content {
      background: #ffffff;
      overflow: hidden;
      border-radius: 10px;
      box-shadow: 4px 6px 10px 0 rgba(0, 0, 0, 0.16);
      padding: 20px 20px 0;
      @media (min-width: 550px) {
        padding: 50px 50px 0;
      }
    }
    &__detail {
      text-align: center;
      padding: 0 0 20px;
    }
    &__list {
      @media (min-width: 1000px) {
        display: flex;
        flex-wrap: wrap;
      }
    }
    &__item {
      position: relative;
      font-weight: 300;
      padding: 5px 0 0 55px;
      margin: 0 0 30px 0;
      @media (min-width: 550px) {
        padding: 10px 0 0 75px;
        margin: 0 0 50px 0;
      }
      @media (min-width: 1000px) {
        padding: 10px 80px 0 75px;
        width: 50%;
        min-width: 50%;
        max-width: 50%;
      }
      h2 {
        padding-bottom: 10px;
        font-size: 14px;
        @media (min-width: 550px) {
          font-size: 16px;
        }
      }
      p {
        font-size: 12px;
        @media (min-width: 550px) {
          font-size: 14px;
        }
      }
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
      height: 30px;
      @media (min-width: 550px) {
        height: 40px;
      }
    }
  }
</style>
